export const valueToArrayFilterOperator = () => ({
  label : 'isAnyIn',
  headerLabel : 'isAnyIn',
  value : 'isAnyIn',
  getApplyFilterFn : (filterItem : any) => {
    if (!filterItem.field || !filterItem.value || !filterItem.operator) {
      return null;
    }
    return (value : string) => {
      const filterValue = filterItem.value as string[];
      return filterValue.includes(value);
    }
  }
})

export const arrayToArrayFilterOperator = () => ({
  label : 'isAnyIn',
  headerLabel : 'isAnyIn',
  value : 'isAnyIn',
  getApplyFilterFn : (filterItem : any) => {
    if (!filterItem.field || !filterItem.value || !filterItem.operator) {
      return null;
    }
    return (value : string[]) => {
      const filterValue = filterItem.value as string[];
      return filterValue.some(fv => value.includes(fv));
    }
  }
})

export const arrayToObjectFilterOperator = () => ({
  label : 'isAnyIn',
  headerLabel : 'isAnyIn',
  value : 'isAnyIn',
  getApplyFilterFn : (filterItem : any) => {

    if (!filterItem.field || !filterItem.value || !filterItem.operator) {
      return null;
    }
    return (cellValue : Record<string, string>) => {
      const filterValue = filterItem.value as string[];
      for (const val of filterValue) {
        const [key, value] = val.split('|');
        if (Object.keys(cellValue).includes(key) && cellValue[key] === value) {
          return true
        }
      }
      return false;
    }
  }
})

export const arrayToObjectArrayFilterOperator = () => ({
  label : 'isAnyIn',
  headerLabel : 'isAnyIn',
  value : 'isAnyIn',
  getApplyFilterFn : (filterItem : any) => {

    if (!filterItem.field || !filterItem.value || !filterItem.operator) {
      return null;
    }
    return (cellValue : Record<string, string[]>) => {
      const filterValue = filterItem.value as string[];
      for (const val of filterValue) {
        const [key, value] = val.split('|');
        if (Object.keys(cellValue).includes(key) && cellValue[key].includes(value)) {
          return true
        }
      }
      return false;
    }
  }
})